module.exports=function(scope){ return `curl -X GET \
  'https://api.zoomauth.com/api/v2/biometrics/status' \
  -H 'X-Device-License-Key: ${scope.appToken}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/test-connection.bash.tpl